<template>
    <div class="wrap-content customer-section">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-9 filter-title-section">
                    <h2>Bulk Customers</h2>
                </div>
                <!-- <div class="col-md-7">
                    <div class="file-upload-info">
                        <div
                            v-if="last_updated_date"
                            class="download-current-file"
                        >
                            <button
                                :disabled="loading"
                                class="btn btn-link"
                                @click.prevent="startDownload()"
                            >
                                <i class="icon-export"></i>

                                <span class="btn-text"
                                    >Download Current Data File</span
                                >
                            </button>
                        </div>
                        <div class="file-last-update">
                            <p>
                                Last updated on
                                <span>{{
                                    last_updated_date
                                        ? last_updated_date
                                        : 'Not updated'
                                }}</span>
                            </p>
                        </div>
                        
                    </div>
                </div> -->
                <div class="col-md-3 text-right export-file-btn">
                    <div v-if="last_updated_date">
                        <b-form-group>
                            <b-button
                                type="button"
                                variant="secondary"
                                class="secondary-add-btn"
                                @click.prevent="startDownload()"
                            >
                                <span class="btn-text">DOWNLOAD EXCEL</span>
                            </b-button>
                        </b-form-group>
                    </div>
                </div>
            </div>
        </div>

        <div
            :class="[
                'table-section',
                'table-min-width',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table
                :items="data"
                :fields="fields"
                no-local-sorting
                @sort-changed="sortingChanged"
            >
                <template slot="fullName" slot-scope="data">
                    {{ data.item.info.CUSTOMER_NAME | titleCase }}
                </template>
                <template slot="fatherName" slot-scope="data">
                    {{ data.item.info.FATHERS_NAME | titleCase }}
                </template>
                <template slot="dateOfBirth" slot-scope="data">
                    {{ data.item.info.DATE_OF_BIRTH | titleCase }}
                </template>
                <template slot="nationality" slot-scope="data">
                    {{ data.item.info.NATIONALITY | titleCase }}
                </template>
                <template slot="cnic" slot-scope="data">
                    {{ data.item.info.CNIC | titleCase }}
                </template>

                <!-- Join Date -->
                <template slot="updated_date" slot-scope="data">
                    {{ data.item.createdAt | moment('MMM D, YYYY h:mm a') }}
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>
        <base-records
            path="customers/import-bulk-customers/"
            :query="query"
            :reset="reset"
            :show-pagination="true"
        ></base-records>

        <export-process-popup
            :id="id"
            title="Export Customer's Data"
            :url="cancelUrl"
        ></export-process-popup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import exportProcessPopup from '@/components/popups/ExportProcessPopup.vue'
import request from '@/utils/request'
const headers = {
    Authorization: `Bearer ${localStorage.getItem('vueauth_token')}`,
}
import axios from 'axios'
const apiUrl_data = process.env.VUE_APP_API_URL
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'data',
            'showPageLoader',
            'loading',
            'dataSegmentId',
            'hasScopes',
        ]),
    }, // End of Component > props
    components: {
        exportProcessPopup,
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        bulkErrorRecords: {
            type: Array,
            default: null,
        },
        updatedDate: {
            type: String,
        },
    }, // End of Component > components
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            fields: {
                fullName: {
                    label: 'FULL NAME',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Full Name',
                    },
                },
                fatherName: {
                    label: 'FATHER NAME',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Father Name',
                    },
                },
                dateOfBirth: {
                    label: 'DATE OF BIRTH',
                    tdAttr: {
                        dataname: 'Date Of Birth',
                    },
                    sortable: true,
                },
                nationality: {
                    label: 'NATIONALITY',
                    tdAttr: {
                        dataname: 'Nationality',
                    },
                },
                cnic: {
                    label: 'CNIC',
                    tdAttr: {
                        dataname: 'Cnic',
                    },
                },

                updated_date: {
                    label: 'Updated Date',
                    sortable: true,
                    tdAttr: {
                        dataname: 'updated_date',
                    },
                    sortable: true,
                },
            },
            path: 'customers/import-bulk-customers/',
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                status: null,
                type: 'bulkCustomersOnboarding',
            },
            reset: new Date().getTime(),
            id: null,
            cancelUrl: 'customers/cancel-export-bulk',
            url: '',
            DowmLoadFileName: '',
            updated_date: null,
            disabled: false,
        }
    },
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.$store.commit('showPageLoader', true)
                this.importBulkCustomers()
            }
        },
        //  updated_date(value){
        //       this.importStatisticsData()
        //     //console.log("upd date ", value)

        //     return value
        // }
    },
    mounted() {
        ////console.log('DATA ', this.data)
    },
    mounted() {
        this.importBulkCustomers()
    }, // End of Component > data

    methods: {
        async importBulkCustomers() {
            try {
                let data = await axios.get(
                    apiUrl_data +
                        'customers/get-bulk-customers/' +
                        this.dataSegmentId,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${localStorage.getItem(
                                'vueauth_token'
                            )}`,
                        },
                    }
                )
                if (data) {
                    ////console.log('data.data.data ', data.data.data)
                    this.last_updated_date = data.data.data.lastUpdatedAt
                    this.url = data.data.data.fileURL
                    this.DowmLoadFileName = data.data.data.fileName
                } else {
                    ////console.log(data.message)
                }
            } catch (e) {
                ////console.log(e)
            }
            this.$store.commit('showPageLoader', false)
        },
        // async exportRecords() {
        //     try {
        //         this.query.dataSegmentId = this.dataSegmentId

        //         let { data } = await request.post(
        //             'customers/export-bulk-customers',
        //             null,
        //             {
        //                 params: this.query,
        //             }
        //         )

        //         // //console.log('data  ' + JSON.stringify(data))

        //         this.id = data.data.id
        //         // this.$bvModal.show('export-process-popup')

        //         this.$toasted.show(data.message, {
        //             type: 'success',
        //         })
        //         await this.importBulkCustomers()
        //     } catch (error) {
        //         // //console.log(error, 'error')
        //     }
        // }, // End of exportRecords() method

        startDownload() {
            axios({
                method: 'get',
                url: this.url,
                responseType: 'arraybuffer',
                headers: headers,
            })
                .then((response) => {
                    this.forceFileDownload(response)
                })
                .catch(() => console.log('error occured'))
        },

        forceFileDownload(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', this.DowmLoadFileName)
            document.body.appendChild(link)
            link.click()
        },
    }, // End of Component > methods
}
</script>

<style></style>
